import React from 'react';
import styled from 'styled-components';
import Routes from './components/Templates/Routes';
import Header from './components/Templates/Header';
import Providers from './components/Templates/Providers';
import Footer from './components/Templates/Footer';
import RepresentationSelector from './components/Molecules/RepresentationSelector';

function App() {
  return (
    <Providers>
      <AppContainer className="container" id="representationselectorui-app">
        <Routes Header={Header} ContentSection={RepresentationSelector} Footer={Footer} />
      </AppContainer>
    </Providers>
  );
}

const AppContainer = styled.main`
  width: 100%;
`;

export default App;
